<!--
 * @Author: robinhu 664196660@qq.com
 * @Date: 2024-07-21 17:51:20
 * @LastEditors: robinhu 664196660@qq.com
 * @LastEditTime: 2025-04-07 17:13:22
 * @FilePath: /admin-h5-page/src/App.vue
 * @Description: 程序主组件
-->
<template>
  <div class="main">
    <el-config-provider :locale="zhCn">
      <router-view></router-view>
    </el-config-provider>
  </div>
</template>
<script setup>
import { ref, computed } from "vue"
import { useRouter } from 'vue-router';
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import { useStore } from 'vuex'

window.document.title = '租户管理系统-个人'
// window.document.title = '吉祥团餐'
const store = new useStore();
const router = useRouter();

try {
  let user = localStorage.getItem('user');
  store.state.user = JSON.parse(user);
} catch(e) {

}

</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100vh;

  .gl-loading {
    position: fixed;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    z-index: 100000;
    background: bottom;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgb(93 94 95 / 77%);
  }
}

.main {
  height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;
}
.pointer{
  cursor: pointer;
}

</style>
